import common from "./modules/common";
import newProduct from "./modules/newProduct";
import system from "./modules/system";
import productCode from "./modules/productCode";
import baseDataXT from "./modules/baseDataXT";
import countryCode from "./modules/countryCode";
import brand from "./modules/brand";
import material from "./modules/material";
import productType from "./modules/productType";
import salePerson from "./modules/salePerson";
import createCode from "./modules/createCode";
import dictionaries from "./modules/dictionaries";
import inquiryCode from "./modules/inquiryCode";
import mediaType from "./modules/mediaType";
import brandType from "./modules/brandType";
import activities from "./modules/activities";
import marketingEnd from "./modules/marketingEnd";
import marketingSX from "./modules/marketingSX";
import marketingSXTJ from "./modules/marketingSXTJ";
import shootTJ from "./modules/shootTJ";
import scanCodeStatistics from "./modules/scanCodeStatistics";
import repetition from "./modules/repetition";

const routes = [
  ...common,
  ...newProduct,
  ...system,
  ...productCode,
  ...baseDataXT,
  ...countryCode,
  ...brand,
  ...material,
  ...productType,
  ...salePerson,
  ...createCode,
  ...dictionaries,
  ...inquiryCode,
  ...mediaType,
  ...brandType,
  ...activities,
  ...marketingEnd,
  ...marketingSX,
  ...marketingSXTJ,
  ...shootTJ,
  ...scanCodeStatistics,
  ...repetition
];
export default routes;
